<script>
import { pageHomeEmits, pageHomeProps, usePageHome } from "./mixin";
import PageContenu from "@/components/pages/infos-et-services/page-contenu/default";
import Carousel from "@/components/organisms/carousel";
import CarouselSlide from "@/components/organisms/carousel/carousel-slide";
import PushProductBlock from "@/components/organisms/push-products-block/default";
import Prospectus from "@/components/molecules/prospectus";
import ProductsSelection from "@/components/organisms/products-selection";
import Popin from "@/components/molecules/popin";
import Container from "@/components/atoms/container";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import Card from "@/components/molecules/card";
import PlanningCommunesSelector from "@/containers/planning/planning-communes-selector";
import Alert from "@/components/molecules/alert";
import Titre from "@/components/atoms/titre";
import WidgetPlanning from "@/containers/planning/widget-planning";
import Planning from "@/containers/planning";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import AbonnementRenouvellement from "@/components/organisms/abonnement-lad/panier/renouvellement/default";
import AbonnementLadBanniere from "@/containers/abonnement-lad/banner";
import ModesCommandeBanniere from "@/components/organisms/mode-commande-overview/modes-commande-banniere";
import ModeCommandeOverview from "@/components/organisms/mode-commande-overview/default";
import CmsFetcher from "@/containers/cms-fetcher";
import CheckLad from "@/components/organisms/check-lad";
import Button from "@/components/atoms/button";
import LazyImage from "@/components/atoms/lazy-image";
import ContactInfoCorapro from "@/components/organisms/contact-infos-corapro/home";
import LinkTo from "@/components/atoms/link-to/link";
import {
  useAbonnementLadBanner,
  ABO_LAD_HOME_COOKIE_NAME
} from "@/composables/abonnement-lad";

import banniereCorapro from "@/assets/images/banniere-corapro-devis.jpg";
import { pushProps } from "../mixins/push-mixin";

export default {
  name: "HomePage",
  components: {
    Carousel,
    CarouselSlide,
    PushProductBlock,
    ProductsSelection,
    Prospectus,
    Popin,
    Container,
    GridRow,
    GridCol,
    PlanningCommunesSelector,
    Card,
    WidgetPlanning,
    Planning,
    Alert,
    HtmlParser,
    PageContenu,
    Titre,
    AbonnementRenouvellement,
    AbonnementLadBanniere,
    ModesCommandeBanniere,
    ModeCommandeOverview,
    CmsFetcher,
    CheckLad,
    Button,
    LazyImage,
    ContactInfoCorapro,
    LinkTo
  },
  data() {
    return {
      cardsModesCommandeMiseEnAvant: ["LAD", "LC", "DRIVE", "PRP", "CC"]
    };
  },
  computed: {
    getProspectusGridColNumber() {
      return this.isNational ? "12" : "6";
    },
    getShippingGridColNumber() {
      return this.prospectusShow ? "3" : "6";
    },
    modeDeCollecteNumber() {
      const nb = this.cardsModesCommandeMiseEnAvant.filter(
        (element) => this.modesCommandeByType[element]
      );
      return nb.length;
    },
    limitedProspectus() {
      return this.prospectus.slice(0, 4);
    }
  },
  props: {
    ...pageHomeProps(),
    ...pushProps()
  },
  emits: [...pageHomeEmits()],
  setup(props, context) {
    const deliveryTermsPopin = ref(null);
    const { isClosedLad, closeLadBanner } = useAbonnementLadBanner(
      ABO_LAD_HOME_COOKIE_NAME
    );
    const {
      showShippingPopin,
      showCountriesListPopin,
      showPlanningPopin,
      showTarifLadPopin,
      showCCPopin,
      showLCPopin,
      deliveryMode,
      communes,
      noCommunes,
      isEligible,
      commune,
      infoMessages,
      alertMessages,
      legalContent,
      isPro,
      prospectusShow,
      pushListSlider,
      pushHpProduits,
      showRecettes,
      recettePosition,
      modesCommandeByType,
      abonnementExpireInCurrentMagasin,
      isEasyBox,
      contactsCorapro,
      onProductIntersect,
      toggleCountriesListPopin,
      closeCountriesListPopin,
      closeCCPopin,
      closeLCPopin,
      closeTarifLadPopin,
      toggleShippingPopin,
      togglePlanningPopin,
      closePlanningPopin,
      fetchCommunes,
      communeValidated,
      resetCommunes,
      communeSelected,
      resetCommune,
      getDeliveryTermsContent,
      openStoreLocator,
      callToActionModeCommandeOverview,
      actionSecondaireModeCommandeOverview,
      getPushProductsFromTransformed,
      getPushListFromTransformed,
      getPushTitleFromTransformed,
      getPushDataFromTransformed,
      mounted,
      HomepageCodes
    } = usePageHome(props, context, deliveryTermsPopin);

    onMounted(mounted);

    return {
      isClosedLad,
      closeLadBanner,
      showShippingPopin,
      showCountriesListPopin,
      showPlanningPopin,
      showTarifLadPopin,
      showCCPopin,
      showLCPopin,
      deliveryMode,
      communes,
      noCommunes,
      isEligible,
      commune,
      infoMessages,
      alertMessages,
      legalContent,
      isPro,
      prospectusShow,
      pushListSlider,
      pushHpProduits,
      showRecettes,
      recettePosition,
      modesCommandeByType,
      abonnementExpireInCurrentMagasin,
      isEasyBox,
      contactsCorapro,
      onProductIntersect,
      toggleCountriesListPopin,
      closeCountriesListPopin,
      closeCCPopin,
      closeLCPopin,
      closeTarifLadPopin,
      toggleShippingPopin,
      togglePlanningPopin,
      closePlanningPopin,
      fetchCommunes,
      communeValidated,
      resetCommunes,
      communeSelected,
      resetCommune,
      getDeliveryTermsContent,
      openStoreLocator,
      callToActionModeCommandeOverview,
      actionSecondaireModeCommandeOverview,
      getPushProductsFromTransformed,
      getPushListFromTransformed,
      getPushTitleFromTransformed,
      getPushDataFromTransformed,
      HomepageCodes,
      banniereCorapro,
      deliveryTermsPopin
    };
  }
};
</script>

<template>
  <div class="u-bgcolor-white">
    <template v-if="modesCommandeByType['LAD']">
      <Popin
        :visible="showTarifLadPopin"
        aria-label="Tarifs livraison"
        @closed="closeTarifLadPopin"
      >
        <CmsFetcher link="/legal/informations-juridiques/infos-tarifs-livraison" />
      </Popin>
      <Popin
        :visible="showLCPopin"
        aria-label="Informations livraison collaborative"
        size="lg"
        @closed="closeLCPopin"
      >
        <CmsFetcher link="/infos-et-services/sinformer/livraison-collaborative" />
      </Popin>
      <Popin
        :visible="showCCPopin"
        aria-label="Informations Click & Collect"
        @closed="closeCCPopin"
      >
        <CmsFetcher link="/infos-et-services/sinformer/click-collect" />
      </Popin>
      <Popin
        :visible="showShippingPopin"
        aria-label="Vérifiez si votre commune peut être livrée par Cora"
        @closed="toggleShippingPopin"
      >
        <CheckLad
          :communes="communes"
          :is-eligible="isEligible"
          :state="noCommunes ? 'error' : 'success'"
          @toggleCountriesListPopin="toggleCountriesListPopin"
          @communeSelected="communeSelected"
          @codePostalSelected="fetchCommunes"
          @communeValidated="communeValidated"
          @resetCommunes="resetCommunes"
          @getDeliveryTermsContent="getDeliveryTermsContent"
          @togglePlanningPopin="togglePlanningPopin"
        />
      </Popin>
    </template>
    <Popin
      :visible="showCountriesListPopin"
      aria-label="Liste des villes livrées par le magasin"
      size="lg"
      @closed="closeCountriesListPopin"
    >
      <h2 class="u-color-primary u-font-700 u-font-secondary u-font-24 u-text-center u-mb-md">
        Liste des villes livrées par le magasin {{ shopName }}
      </h2>
      <PlanningCommunesSelector
        class="u-pl-lg u-pr-lg u-pb-md"
        @communeSelected="communeSelected"
      />
    </Popin>
    <Popin
      :visible="commune !== null"
      size="lg"
      aria-label="Planning"
      @closed="resetCommune()"
    >
      <Planning
        v-if="showCountriesListPopin && commune"
        :selectable="false"
        :service-id="serviceLadId"
        :code-postal="commune ? commune.attributes.code_postal : null"
        :code-insee="commune ? commune.attributes.code_insee : null"
      />
    </Popin>
    <Popin
      ref="planning"
      aria-label="Planning"
      :visible="showPlanningPopin"
      size="lg"
      @closed="closePlanningPopin"
    >
      <WidgetPlanning
        :commune="commune"
        :type="deliveryMode"
      />
    </Popin>
    <Popin
      ref="deliveryTermsPopin"
      aria-label="Termes légaux de la livraison"
      size="lg"
    >
      <PageContenu
        v-if="legalContent"
        :context="'legal'"
        :cms-reponse="legalContent"
      />
    </Popin>
    <div class="u-py-lg Desk_HP_Slider">
      <div class="c-encart-merch c-encart-merch--slider-hp">
        <div class="c-encart-merch-item c-encart-merch-item--large">
          <Carousel
            v-if="pushListSlider.length > 0"
            :key="pushListSlider.length"
            elements-per-slide="auto"
            auto-play
            navigation-arrows
            loop
            :auto-play-delay="5000"
            :speed="700"
            bullets
            pagination-size="sm"
            pagination-position="right"
            pagination-block
            navigation-size="md"
            navigation-icon-color="primary"
            navigation-icon-color-hover="secondary"
            full-img
            variant="hp"
            class="c-encart-merch-item__slider"
          >
            <CarouselSlide
              v-for="(sliderPush, i) in pushListSlider"
              :key="`carousel-hp-${i}`"
              :diapo-number="i + 1"
            >
              <HtmlParser
                class="c-carousel__slide-img"
                :promo-printing="true"
                context="HP MEA carousel "
                :push-data="sliderPush"
              />
            </CarouselSlide>
          </Carousel>
        </div>

        <HtmlParser
          class="c-encart-merch-item c-encart-merch-item--medium"
          :context="
            `HP DOITE SLIDER : ${getPushTitleFromTransformed(
              isPro ? HomepageCodes.PRO_HP_DROITE_SLIDER : HomepageCodes.HP_DROITE_SLIDER
            )} `
          "
          :promo-printing="true"
          :push-data="
            getPushDataFromTransformed(isPro ? HomepageCodes.PRO_HP_DROITE_SLIDER : HomepageCodes.HP_DROITE_SLIDER)
          "
        />

        <template v-if="getPushListFromTransformed(isPro ? HomepageCodes.PRO_HP_BAS_SLIDER : HomepageCodes.HP_BAS_SLIDER).length >= 4">
          <div class="c-encart-merch c-encart-merch--dual">
            <HtmlParser
              class="c-encart-merch-item c-encart-merch-item--small"
              :context="`HP BAS SLIDER : ${getPushTitleFromTransformed(isPro ? HomepageCodes.PRO_HP_BAS_SLIDER : HomepageCodes.HP_BAS_SLIDER)} `"
              :promo-printing="true"
              :push-data="getPushDataFromTransformed(isPro ? HomepageCodes.PRO_HP_BAS_SLIDER : HomepageCodes.HP_BAS_SLIDER)"
            />
            <HtmlParser
              class="c-encart-merch-item c-encart-merch-item--small"
              :context="`HP BAS SLIDER : ${getPushTitleFromTransformed(isPro ? HomepageCodes.PRO_HP_BAS_SLIDER : HomepageCodes.HP_BAS_SLIDER, 2)} `"
              :promo-printing="true"
              :push-data="getPushDataFromTransformed(isPro ? HomepageCodes.PRO_HP_BAS_SLIDER : HomepageCodes.HP_BAS_SLIDER, 2)"
            />
          </div>
          <div class="c-encart-merch c-encart-merch--dual">
            <HtmlParser
              class="c-encart-merch-item c-encart-merch-item--small"
              :context="`HP BAS SLIDER : ${getPushTitleFromTransformed(isPro ? HomepageCodes.PRO_HP_BAS_SLIDER : HomepageCodes.HP_BAS_SLIDER, 3)} `"
              :promo-printing="true"
              :push-data="getPushDataFromTransformed(isPro ? HomepageCodes.PRO_HP_BAS_SLIDER : HomepageCodes.HP_BAS_SLIDER, 3)"
            />
            <HtmlParser
              class="c-encart-merch-item c-encart-merch-item--small"
              :context="`HP BAS SLIDER : ${getPushTitleFromTransformed(isPro ? HomepageCodes.PRO_HP_BAS_SLIDER : HomepageCodes.HP_BAS_SLIDER, 4)} `"
              :promo-printing="true"
              :push-data="getPushDataFromTransformed(isPro ? HomepageCodes.PRO_HP_BAS_SLIDER : HomepageCodes.HP_BAS_SLIDER, 4)"
            />
          </div>
        </template>
      </div>
    </div>
    <client-only>
      <div
        v-if="infoMessages || alertMessages"
        class="u-mt-lg u-mb-lg20"
      >
        <Container>
          <Alert
            v-if="alertMessages"
            radius="md"
            class="u-mb-sm"
          >
            <p class="u-color-secondary">
              {{ uppercaseFirstLetter(alertMessages) }}
            </p>
          </Alert>
          <Alert
            v-if="infoMessages"
            radius="md"
          >
            <p class="u-color-primary">
              {{ uppercaseFirstLetter(infoMessages) }}
            </p>
          </Alert>
        </Container>
      </div>
    </client-only>
    <HtmlParser
      v-if="getPushDataFromTransformed(HomepageCodes.HP_BANDEAU_FULL).html_content && !isPro"
      :context="`HP BANDEAU FULL : ${getPushTitleFromTransformed(HomepageCodes.HP_BANDEAU_FULL)}`"
      :promo-printing="true"
      :push-data="getPushDataFromTransformed(HomepageCodes.HP_BANDEAU_FULL)"
    />
    <!-- je préfère sortir le titre car il y a trop de paramètre qui varie  tag, marge, padding, font, font-size et qu'il et plus simple de gérer via utilitaires que prop -->
    <div
      v-if="!isPro"
      class="u-bgcolor-bg u-pt-md u-pb-md Desk_HP_Livraison_1"
    >
      <Container>
        <template v-if="isNational">
          <NuxtLazyHydrate when-visible>
            <Card
              border-color="border"
              radius="lg"
              class="u-p-md u-my-xs"
            >
              <ModesCommandeBanniere @openStoreLocator="openStoreLocator" />
            </Card>
          </NuxtLazyHydrate>
        </template>
        <template v-else>
          <h2
            id="modesCommandeHp"
            class="u-font-secondary u-color-primary u-font-32 u-text-center u-mb-md"
          >
            Vos courses où vous voulez !
          </h2>
          <div class="u-flex u-flex-justify-center">
            <template
              v-for="typeMdc in cardsModesCommandeMiseEnAvant"
              :key="typeMdc"
            >
              <Card
                v-if="modesCommandeByType[typeMdc]"
                border-color="border"
                radius="lg"
                class="u-p-xs25 u-mx-xs u-full-width"
                :class="modeDeCollecteNumber >= 4 && 'u-flex-item-fluid'"
                :style="modeDeCollecteNumber < 4 && 'max-width:30rem'"
              >
                <NuxtLazyHydrate when-visible>
                  <ModeCommandeOverview
                    :mode-commande="modesCommandeByType[typeMdc]"
                    @callToAction="callToActionModeCommandeOverview"
                    @actionSecondaire="actionSecondaireModeCommandeOverview"
                  />
                </NuxtLazyHydrate>
              </Card>
            </template>
          </div>
          <template v-if="modesCommandeByType['CEV']">
            <Card
              border-color="border"
              radius="lg"
              class="u-p-sm u-mt-sm u-mx-xs"
            >
              <ModeCommandeOverview
                :mode-commande="modesCommandeByType['CEV']"
                horizontal
                @callToAction="callToActionModeCommandeOverview"
                @actionSecondaire="actionSecondaireModeCommandeOverview"
              />
            </Card>
          </template>
          <template v-if="isEasyBox">
            <Card
              border-color="border"
              radius="lg"
              class="u-p-sm u-mt-sm u-mx-xs"
            >
              <ModeCommandeOverview
                :mode-commande="modesCommandeByType['PRC']"
                horizontal
                @callToAction="callToActionModeCommandeOverview"
                @actionSecondaire="actionSecondaireModeCommandeOverview"
              />
            </Card>
          </template>
          <template v-if="modesCommandeByType['PRC_DELIPOP']">
            <Card
              border-color="border"
              radius="lg"
              class="u-p-sm u-mt-sm u-mx-xs"
            >
              <ModeCommandeOverview
                :mode-commande="modesCommandeByType['PRC_DELIPOP']"
                horizontal
                @callToAction="callToActionModeCommandeOverview"
                @actionSecondaire="actionSecondaireModeCommandeOverview"
              />
            </Card>
          </template>
        </template>
      </Container>
    </div>
    <div
      v-if="showAboLad && !isClosedLad"
      class="u-bgcolor-bg u-p-lg Desk_HP_Livraison_2"
    >
      <NuxtLazyHydrate when-visible>
        <Container>
          <AbonnementRenouvellement
            v-if="abonnementExpireInCurrentMagasin"
            @close="closeLadBanner"
          />
          <AbonnementLadBanniere
            v-else
            class="u-mx-xs25"
            @close="closeLadBanner"
          />
        </Container>
      </NuxtLazyHydrate>
    </div>
    <NuxtLazyHydrate
      v-if="prospectusShow && !isPro"
      when-visible
    >
      <div class="u-text-center u-py-md Desk_HP_Prospectus">
        <Container>
          <Titre
            tag="h2"
            variant="primary"
            size="xlg"
            class="u-mb-md"
          >
            Faites des économies en consultant les prospectus
          </Titre>
          <GridRow class="u-mb-md">
            <template
              v-for="item in limitedProspectus"
              :key="item.id"
            >
              <GridCol class="u-text-center">
                <div class="u-flex u-flex-justify-center u-full-height">
                  <Prospectus
                    :img-path="item.attributes.cover"
                    :period="item.attributes.period"
                    :title="item.attributes.title"
                    :link="item.attributes.url"
                    :start-date="item.attributes.start_at"
                    :page-type="trackingCodes.PAGETYPE.homepage"
                    img-width="132"
                    light
                    class="u-mb-md"
                  />
                </div>
              </GridCol>
            </template>
          </GridRow>
          <Button
            variant="primary"
            link
            to="/prospectus"
          >
            Voir tous les prospectus
          </Button>
        </Container>
      </div>
    </NuxtLazyHydrate>
    <div class="u-bgcolor-bg u-pb-lg"></div>
    <template v-if="pushHpProduits && pushHpProduits.length > 0">
      <h2
        id="pushHpProduits"
        class="u-font-secondary u-color-primary u-font-32 -font-700 u-text-center u-mt-lg20 u-mb-md"
      >
        {{ getPushTitleFromTransformed(isPro ? HomepageCodes.PRO_HP_PRODUITS : HomepageCodes.HP_PRODUITS) }}
      </h2>
      <div class="u-mb-lg20 Desk_HP_Produits">
        <PushProductBlock
          :label="trackingCodes.LABELGA.HP"
          :products="pushHpProduits"
          :push-title="getPushTitleFromTransformed(isPro ? HomepageCodes.PRO_HP_PRODUITS : HomepageCodes.HP_PRODUITS)"
          :is-national="isNational"
          aria-labelledby="pushHpProduits"
          :recette-index="showRecettes ? recettePosition : -1"
          @onProductIntersect="
            (i) => onProductIntersect(i, isPro ? HomepageCodes.PRO_HP_PRODUITS : HomepageCodes.HP_PRODUITS, 1)
          "
        />
      </div>
    </template>
    <Container
      v-if="isPro"
      class="u-pt-lg"
    >
      <h2 class="u-font-secondary u-color-primary u-font-32 u-text-center u-mb-md">
        Votre contact Services pro
      </h2>
      <div class="u-flex u-flex-justify-center u-flex-align-center">
        <ContactInfoCorapro
          v-if="contactsCorapro"
          :contact="contactsCorapro"
          is-home-page
          class="c-home-contact-infos-corapro"
        />
      </div>
      <div class="u-py-lg u-flex u-flex-justify-center">
        <LinkTo
          class="c-home-bandeau-corapro"
          to="/infos-et-services/aide/contactez-nous/formulaire-cora-pro"
        >
          <LazyImage
            :src="banniereCorapro"
            width="1360"
          />
        </LinkTo>
      </div>
    </Container>
    <template v-if="!isPro">
      <div
        v-if="
          getPushProductsFromTransformed(HomepageCodes.HP_BOUTIQUE_PRODUITS_1, 1)
            .length > 0 ||
            getPushProductsFromTransformed(
              HomepageCodes.HP_BOUTIQUE_PRODUITS_2,
              1
            ).length > 0
        "
        class="u-mb-lg Desk_HP_Selections"
      >
        <Container v-if="getPushProductsFromTransformed(HomepageCodes.HP_BOUTIQUE_PRODUITS_1, 1).length > 0 || getPushProductsFromTransformed(HomepageCodes.HP_BOUTIQUE_PRODUITS_2, 1).length > 0">
          <h2
            v-if="getPushTitleFromTransformed(HomepageCodes.HP_BOUTIQUE_MEA_1)"
            class="u-font-secondary u-color-primary u-font-32 u-font-700 u-text-center  u-mt-lg20 u-mb-sm"
          >
            {{ getPushTitleFromTransformed(HomepageCodes.HP_BOUTIQUE_MEA_1) }}
          </h2>
          <ProductsSelection
            v-if="
              getPushProductsFromTransformed(
                HomepageCodes.HP_BOUTIQUE_PRODUITS_1,
                1
              ).length > 0
            "
            :push-data="
              getPushDataFromTransformed(HomepageCodes.HP_BOUTIQUE_MEA_1)
            "
            :products="
              getPushProductsFromTransformed(
                HomepageCodes.HP_BOUTIQUE_PRODUITS_1,
                1,
                3
              )
            "
            class="u-mb-md"
            @onProductIntersect="
              (i) =>
                onProductIntersect(HomepageCodes.HP_BOUTIQUE_PRODUITS_1, 1, 3)
            "
          />
          <ProductsSelection
            v-if="
              getPushProductsFromTransformed(
                HomepageCodes.HP_BOUTIQUE_PRODUITS_2,
                1
              ).length > 0
            "
            :push-data="
              getPushDataFromTransformed(HomepageCodes.HP_BOUTIQUE_MEA_2)
            "
            :products="
              getPushProductsFromTransformed(
                HomepageCodes.HP_BOUTIQUE_PRODUITS_2,
                1,
                3
              )
            "
            class="u-mb-md"
            @onProductIntersect="
              (i) =>
                onProductIntersect(i, HomepageCodes.HP_BOUTIQUE_PRODUITS_2, 1, 3)
            "
          />
        </Container>
      </div>
      <client-only>
        <div
          v-if="getPushListFromTransformed(HomepageCodes.HP_MEA_HAUT).length >= 4|| getPushDataFromTransformed(HomepageCodes.HP_MEA_HAUT_2).html_content"
          class="u-mb-lg Desk_HP_Merch_Bas_1"
        >
          <h2 class="u-font-secondary u-color-primary u-font-32 u-font-700 u-text-center u-mb-md">
            {{ getPushListFromTransformed(HomepageCodes.HP_MEA_HAUT).length >= 4 ? getPushTitleFromTransformed(HomepageCodes.HP_MEA_HAUT) : getPushTitleFromTransformed(HomepageCodes.HP_MEA_HAUT_2) }}
          </h2>
          <div :class="getPushDataFromTransformed(HomepageCodes.HP_MEA_HAUT_2).html_content ? 'u-mb-sm' : ''">
            <div
              v-if="getPushListFromTransformed(HomepageCodes.HP_MEA_HAUT).length >= 4"
              class="c-encart-merch"
            >
              <HtmlParser
                class="c-encart-merch-item c-encart-merch-item--medium"
                :context="
                  `HP MEA HAUT : ${getPushTitleFromTransformed(
                    HomepageCodes.HP_MEA_HAUT
                  )} `
                "
                :promo-printing="true"
                :push-data="
                  getPushDataFromTransformed(HomepageCodes.HP_MEA_HAUT)
                "
              />

              <HtmlParser
                class="c-encart-merch-item c-encart-merch-item--medium"
                :context="
                  `HP MEA HAUT : ${getPushTitleFromTransformed(
                    HomepageCodes.HP_MEA_HAUT
                  )} `
                "
                :promo-printing="true"
                :push-data="
                  getPushDataFromTransformed(HomepageCodes.HP_MEA_HAUT, 2)
                "
              />

              <div class="c-encart-merch c-encart-merch--small-column">
                <HtmlParser
                  class="c-encart-merch-item c-encart-merch-item--small"
                  :context="
                    `HP MEA HAUT : ${getPushTitleFromTransformed(
                      HomepageCodes.HP_MEA_HAUT
                    )} `
                  "
                  :promo-printing="true"
                  :push-data="
                    getPushDataFromTransformed(HomepageCodes.HP_MEA_HAUT, 3)
                  "
                />

                <HtmlParser
                  class="c-encart-merch-item c-encart-merch-item--small"
                  :context="
                    `HP MEA HAUT : ${getPushTitleFromTransformed(
                      HomepageCodes.HP_MEA_HAUT
                    )} `
                  "
                  :promo-printing="true"
                  :push-data="
                    getPushDataFromTransformed(HomepageCodes.HP_MEA_HAUT, 4)
                  "
                />
              </div>
            </div>
          </div>
          <HtmlParser
            v-if="getPushDataFromTransformed(HomepageCodes.HP_MEA_HAUT_2)"
            :context="
              `HP MEA HAUT 2 : ${getPushTitleFromTransformed(
                HomepageCodes.HP_MEA_HAUT_2
              )} `
            "
            promo-printing
            :push-data="
              getPushDataFromTransformed(HomepageCodes.HP_MEA_HAUT_2)
            "
          />
        </div>
      </client-only>
      <client-only>
        <div
          v-if="getPushDataFromTransformed(HomepageCodes.HP_MEA_BAS).html_content"
          class="u-pb-lg Desk_HP_Merch_Bas_2"
        >
          <h2 class="u-font-secondary u-color-primary u-font-32 u-font-700 u-text-center u-mb-sm">
            {{ getPushTitleFromTransformed(HomepageCodes.HP_MEA_BAS) }}
          </h2>
          <HtmlParser
            :class="getPushDataFromTransformed(HomepageCodes.HP_MEA_BAS, 2).html_content ? 'u-mb-sm' : ''"
            :context="
              `HP MEA BAS : ${getPushTitleFromTransformed(
                HomepageCodes.HP_MEA_BAS,
              )} `
            "
            promo-printing
            :push-data="
              getPushDataFromTransformed(HomepageCodes.HP_MEA_BAS)
            "
          />
          <HtmlParser
            v-if="getPushDataFromTransformed(HomepageCodes.HP_MEA_BAS, 2).html_content"
            :context="
              `HP MEA BAS : ${getPushTitleFromTransformed(HomepageCodes.HP_MEA_BAS, 2)} `
            "
            promo-printing
            :push-data="
              getPushDataFromTransformed(HomepageCodes.HP_MEA_BAS, 2)
            "
          />
        </div>
      </client-only>
    </template>
  </div>
</template>

<style lang="scss">
@import "@/assets/styles/components/encart-merch.scss";
.c-home-contact-infos-corapro {
  margin: 0 !important;
  border-radius: radius(md);
  border: 2px solid color(primary-light);
  padding: spacing(sm);
  width: 100%;
}
.c-home-bandeau-corapro {
  border-radius: 1.2rem;
  overflow: hidden;
}
</style>
